import { useState } from 'react';

import icCup from '@/assets/ic_cup2.svg';
import icGCap from '@/assets/ic_gCap.svg';
import { Button, Modal, NavBar, SliderOver } from '@/components';
import { useIsDesktop } from '@/hooks/useIsDesktop';

const InfoButtonSection = ({ isPrimary }: { isPrimary: boolean }) => {
  const { isDesktop, isMobile } = useIsDesktop();
  const [isOpen, setIsOpen] = useState(false);
  const [activeView, setActiveView] = useState<'info' | 'prize'>('info');

  const handleOpenModal = (viewType: 'info' | 'prize') => {
    setActiveView(viewType);
    setIsOpen(true);
  };

  const modalPrimaryContent = {
    info: {
      title: (
        <div className="flex items-center space-x-2 mt-6">
          <div className="bg-gdt-gray-6 rounded-full w-8 h-8 flex items-center justify-center">
            <img
              alt="Icono de titulo Mi Desempeño"
              className="w-5 h-5 text-gdt-blue-light"
              src={icGCap}
            />
          </div>
          <p className="font-bold text-[16px] text-[#2855C6]">
            ¿Qué es el Torneo de Escuelas Primarias y cómo participar?
          </p>
        </div>
      ),
      content: (
        <div className="p-4">
          <p className="text-[14px]">
            El Torneo de Escuelas Primarias es una competencia especial de la
            que{' '}
            <span className="font-bold">
              participan todos los DT’s que sean alumnos regulares de una
              escuela primaria
            </span>{' '}
            y que hayan completado en sus Datos personales los campos de
            provincia, partido, localidad y nombre de la Escuela a la que
            asisten y de la cual son alumnos regulares.
          </p>
          <p className="text-[14px] mt-4">
            Además de la competencia de todos los participantes del Torneo de
            Escuelas Primarias, en paralelo existirá un Ranking de las Escuelas,
            que mostrará los puntos de cada una, donde la mejor posición será
            ocupada por la institución con mejor promedio de puntos. El promedio
            de puntos se obtiene sumando la cantidad total de puntos dividida
            por la cantidad de participantes que declaren ser alumnos de la
            institución. Para que una escuela pueda formar parte del Ranking,
            deberá contar con un mínimo de 2 participantes del Torneo de
            Escuelas.
          </p>
        </div>
      ),
    },
    prize: {
      title: (
        <div className="flex items-center space-x-2 mt-6">
          <div className="bg-gdt-gray-6 rounded-full w-8 h-8 flex items-center justify-center">
            <img
              alt="Icono de titulo Mi Desempeño"
              className="w-5 h-5 text-gdt-blue-light"
              src={icCup}
            />
          </div>
          <p className="font-bold text-[16px] text-[#2855C6]">Premios</p>
        </div>
      ),
      content: (
        <div className="p-4">
          <span className="font-bold text-[14px]">
            El ganador de la Fecha se lleva una pelota de fútbol y el ganador
            del Torneo un Smartphone.
          </span>
        </div>
      ),
    },
  };

  const modalSecondaryContent = {
    info: {
      title: (
        <div className="flex items-center space-x-2 mt-6">
          <div className="bg-gdt-gray-6 rounded-full w-8 h-8 flex items-center justify-center">
            <img
              alt="Icono de titulo Mi Desempeño"
              className="w-5 h-5 text-gdt-blue-light"
              src={icGCap}
            />
          </div>
          <p className="font-bold text-[16px] text-[#2855C6]">
            ¿Qué es el Torneo de Escuelas Secundarias y cómo participar?
          </p>
        </div>
      ),
      content: (
        <div className="p-4">
          <p className="text-[14px]">
            El Torneo de Escuelas Secundarias es una competencia especial de la
            que{' '}
            <span className="font-bold">
              participan todos los DT’s que sean alumnos regulares de una
              escuela secundaria
            </span>{' '}
            y que hayan completado en sus Datos personales los campos de
            provincia, partido, localidad y nombre de la Escuela a la que
            asisten y de la cual son alumnos regulares.
          </p>
          <p className="text-[14px] mt-4">
            Además de la competencia de todos los participantes del Torneo de
            Escuelas Secundarias, en paralelo existirá un Ranking de las
            Escuelas, que mostrará los puntos de cada una, donde la mejor
            posición será ocupada por la institución con mejor promedio de
            puntos. El promedio de puntos se obtiene sumando la cantidad total
            de puntos dividida por la cantidad de participantes que declaren ser
            alumnos de la institución. Para que una escuela pueda formar parte
            del Ranking, deberá contar con un mínimo de 2 participantes del
            Torneo de Escuelas.
          </p>
        </div>
      ),
    },
    prize: {
      title: (
        <div className="flex items-center space-x-2 mt-6">
          <div className="bg-gdt-gray-6 rounded-full w-8 h-8 flex items-center justify-center">
            <img
              alt="Icono de titulo Mi Desempeño"
              className="w-5 h-5 text-gdt-blue-light"
              src={icCup}
            />
          </div>
          <p className="font-bold text-[16px] text-[#2855C6]">Premios</p>
        </div>
      ),
      content: (
        <div className="p-4">
          <span className="font-bold text-[14px]">
            El ganador de la Fecha se lleva una pelota de fútbol y el ganador
            del Torneo un Smart TV 43”.
          </span>
        </div>
      ),
    },
  };

  const modalContent = isPrimary ? modalPrimaryContent : modalSecondaryContent;

  return (
    <>
      {isDesktop && (
        <div className="w-[426px] ml-8 px-5 pb-3 flex items-center justify-center gap-2">
          <Button
            className="pr-4 py-2 text-[14px] text-gdt-blue font-bold"
            href="#"
            type="link"
            variant="text"
            onClick={() => handleOpenModal('info')}
          >
            Más información
          </Button>

          <Button
            className="pr-4 py-2 text-[14px] text-gdt-blue font-bold"
            href="#"
            type="link"
            variant="text"
            onClick={() => handleOpenModal('prize')}
          >
            Premios
          </Button>

          <Modal
            controlledOnClose={() => setIsOpen(false)}
            isControlledOpen={isOpen}
            render={() => modalContent[activeView].content}
            title={modalContent[activeView].title}
            variant="controlled"
          />
        </div>
      )}
      {isMobile && (
        <div>
          <Button
            className="pr-4 py-2 text-[14px] text-gdt-blue font-bold"
            href="#"
            type="link"
            variant="text"
            onClick={() => handleOpenModal('info')}
          >
            Más información y Premios
          </Button>

          <SliderOver open={isOpen}>
            <NavBar
              mobile={{
                leftContent: {
                  backAction: () => setIsOpen(false),
                },
                centerContent: {
                  title: 'Torneo Escuelas Primarias',
                },
              }}
            >
              <div className="bg-gdt-gray-7 h-[calc(100vh-51px)] overflow-y-auto">
                <div className="bg-white rounded-lg flex flex-col m-8">
                  <div className="pl-4">{modalContent.prize.title}</div>
                  {modalContent.prize.content}
                </div>
                <div className="bg-white rounded-lg flex flex-col m-8">
                  <div className="pl-4">{modalContent.info.title}</div>
                  {modalContent.info.content}
                </div>
              </div>
            </NavBar>
          </SliderOver>
        </div>
      )}
    </>
  );
};

export default InfoButtonSection;
